module.exports = "h1 {\n  font-size: 25px;\n  font-weight: bold;\n  margin: 20px 0 15px;\n  color: #626262;\n}\n\n.container-cliente {\n  margin-top: 10px;\n}\n\n.input-ocupacion {\n  width: 100%;\n}\n\n::ng-deep.input-diferent-select .mat-select-value-text {\n  color: red;\n}\n\n.input-diferent-select {\n  color: red;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/cliente/registro-cliente/registro-cliente.component.css
// module id = ./src/app/components/cliente/registro-cliente/registro-cliente.component.css
// module chunks = main